import { normalizeGroupToken } from './groupToken';
import { parseGroupGameId } from './groupGameId';

export interface OnlineIdentitySource {
  gameId?: string | null;
  roomId?: string | null;
  currentRoundId?: string | null;
  groupToken?: string | null;
}

function normalizeIdentityValue(raw: string | null | undefined): string | null {
  const trimmed = (raw || '').trim().toUpperCase();
  return trimmed || null;
}

function resolveOnlineRoomId(source: OnlineIdentitySource | null | undefined): string | null {
  const explicitRoomId = normalizeIdentityValue(source?.roomId);
  if (explicitRoomId) return explicitRoomId;

  const normalizedGroupToken = normalizeGroupToken(source?.groupToken || null);
  if (normalizedGroupToken) return normalizedGroupToken;

  const parsedGroupGameId = parseGroupGameId(source?.gameId || '');
  if (parsedGroupGameId?.groupId) return parsedGroupGameId.groupId;

  return normalizeIdentityValue(source?.gameId);
}

function resolveOnlineRoundId(source: OnlineIdentitySource | null | undefined): string | null {
  return normalizeIdentityValue(source?.currentRoundId)
    || normalizeIdentityValue(source?.gameId);
}

export function resolveOnlineIdentity(source: OnlineIdentitySource | null | undefined): {
  gameId: string | null;
  roomId: string | null;
  currentRoundId: string | null;
} {
  const gameId = normalizeIdentityValue(source?.gameId);
  const roomId = resolveOnlineRoomId(source);
  const currentRoundId = resolveOnlineRoundId(source);
  return { gameId, roomId, currentRoundId };
}